import { getData, postData } from '../../../common/services/network.service';
import type { ImportProjectResponse, ResponseObject } from '../models';

const { PROJECT_GW_BASE_API_URL } = window.ts.globals;

export const getProjects = (projectId: string, callback: (data: ImportProjectResponse) => void, onError: (error?: any) => void) => {
    return getData(
        `${PROJECT_GW_BASE_API_URL}/project/getImportedProject?projectName=${projectId}`,
        (response) => {
            if (response && !response.hasOwnProperty('data')) {
                response.data = [{
                    externalProjectId: response.externalProjectId,
                    projectDbType: response.projectDbType,
                }];
            }
            callback(response);
        },
        onError,
        undefined,
    );
};

export const importProjects = (checkedItems: Array<ResponseObject['externalProjectId']>, data: any, callback: (data: any) => void, onError: (error?: any) => void) => {
    return postData(
        `${PROJECT_GW_BASE_API_URL}/project/importProject?projectId=${checkedItems[0]}`,
        data,
        callback,
        onError,
    );
};
